import { createEmitter } from "../Utilities/events";
import { MediaType, detectMediaType, canPlayNativeHls } from "../Core/MediaTypes";
import { StreamingProviderEvents } from "./StreamingProvider";

/**
 * Native HLS (Safari / iOS / some smart TVs) — no hls.js.
 */
export function createNativeHlsProvider() {
  var emitter = createEmitter();
  var video = null;
  var name = "native-hls";

  return {
    getName: function () {
      return name;
    },
    getSurfaceKind: function () {
      return "video";
    },
    initialize: function () {
      return Promise.resolve();
    },
    supports: function (source) {
      if (!source || !source.src) {
        return false;
      }
      var type = source.type || detectMediaType(source.src);
      return type === MediaType.HLS && canPlayNativeHls();
    },
    attach: function (el) {
      video = el;
    },
    detach: function () {
      video = null;
    },
    load: function (source) {
      if (!video) {
        return Promise.reject(new Error("native-hls: video not attached"));
      }
      if (source.poster) {
        video.poster = source.poster;
      }
      video.src = source.src;
      video.load();
      return new Promise(function (resolve, reject) {
        var settled = false;
        var onOk = function () {
          if (settled) return;
          settled = true;
          cleanup();
          resolve();
        };
        var onFail = function () {
          if (settled) return;
          settled = true;
          cleanup();
          reject({
            code: "NATIVE_HLS_ERROR",
            message: "Native HLS playback failed",
            recoverable: true,
          });
        };
        var cleanup = function () {
          video.removeEventListener("canplay", onOk);
          video.removeEventListener("error", onFail);
        };
        video.addEventListener("canplay", onOk);
        video.addEventListener("error", onFail);
      });
    },
    getLevels: function () {
      // Native HLS does not expose rendition APIs uniformly.
      return [];
    },
    setLevel: function () {},
    getCurrentLevel: function () {
      return -1;
    },
    on: emitter.on,
    off: emitter.off,
    destroy: function () {
      if (video) {
        video.removeAttribute("src");
        try {
          video.load();
        } catch (e) {
          /* ignore */
        }
      }
      video = null;
      emitter.emit(StreamingProviderEvents.DESTROYED);
      emitter.removeAllListeners();
    },
  };
}

export default createNativeHlsProvider;
